import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './components/views/Dashboard';
import Pipeline from './components/views/Pipeline';
import Projects from './components/views/Projects';
import Invoices from './components/views/Invoices';
import Guide from './components/views/Guide';
import { initialInvoices } from './data/mockData';
import './index.css';

function App() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [invoices, setInvoices] = useState(initialInvoices);

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard': return <Dashboard />;
      case 'pipeline': return <Pipeline />;
      case 'projects': return <Projects />;
      case 'invoices': return <Invoices invoices={invoices} setInvoices={setInvoices} />;
      case 'guide': return <Guide />;
      default: return <Dashboard />;
    }
  };

  return (
    <div className="flex h-screen w-full bg-charcoal-base overflow-hidden selection:bg-invoice-green/30">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <div className="flex-1 flex flex-col h-full relative overflow-hidden">
        <Header setActiveTab={setActiveTab} />
        
        <main className="flex-1 overflow-y-auto custom-scrollbar p-4 md:p-8 relative">
          <div className="max-w-7xl mx-auto h-full flex flex-col">
            <div className="flex-1">
              {renderContent()}
            </div>
            
            <footer className="mt-12 pt-6 border-t border-[#222] text-center shrink-0 pb-6">
              <p className="text-xs text-[#FDFBF7]/40 tracking-[0.2em] font-medium uppercase">
                Made by LingLink AI and DigLab AI
              </p>
            </footer>
          </div>
        </main>
      </div>

      {/* Mobile Menu Overlay */}
      {activeTab === 'menu' && (
        <div className="fixed inset-0 bg-charcoal-base z-50 p-6 flex flex-col md:hidden">
          <div className="flex justify-between items-center mb-8">
            <div className="flex items-center gap-3 text-cream font-semibold text-xl">
              <div className="w-8 h-8 rounded-lg bg-invoice-green flex items-center justify-center">
                <span className="text-[#111] font-bold">S</span>
              </div>
              StudioLedger
            </div>
            <button onClick={() => setActiveTab('dashboard')} className="text-cream-muted">
              <SafeIcon name="X" className="w-6 h-6" />
            </button>
          </div>
          <div className="flex flex-col gap-4">
            {['dashboard', 'pipeline', 'projects', 'invoices', 'guide'].map(tab => (
              <button 
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`text-left text-lg py-3 capitalize border-b border-[#333] transition-colors ${
                  activeTab === tab ? 'text-invoice-green' : 'text-cream-muted'
                }`}
              >
                {tab.replace('-', ' ')}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;